var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as go from '../../../../libs/gojs/release/go';
import { VariableDefinition } from '@flexem/fc-gui';
import { NodeElement } from './base/node-element';
import { BarDirectionType } from '../utils/bar-graph/bar-direction-type';
import { DiagramConsts } from '../diagram-consts';
import { BarGraphConsts } from '../../element-setting/bar-graph/bar-graph-consts';
import { CalibrationGoModelToDataUtil } from '../../element-setting/shared/calibration-mark/calibration-go-model-to-data-util';
import { DataType } from '../../../../main/workshop/core/variable/data-type';
var BarGraphElement = /** @class */ (function (_super) {
    __extends(BarGraphElement, _super);
    function BarGraphElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarGraphElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        if (data.variableVersion) {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === data.variableName; });
            if (null != variable) {
                model['readVariable'] = { name: data.variableName, variableVersion: data.variableVersion };
            }
        }
        else {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === data.dataSourceCode
                && v.fBoxVariableName === data.variableName && (!data.variableGroupName || (v.fBoxGroupName === data.variableGroupName)); });
            if (null != variable) {
                model['readVariable'] = new VariableDefinition(variable.fBoxVariableName, variable.fBoxGroupName, variable.dataSourceCode);
            }
        }
        model['direction'] = data.direction;
        model['min'] = data.min;
        model['max'] = data.max;
        model['integerDigits'] = data.integerDigits;
        model['fractionDigits'] = data.fractionDigits;
        model['barColor'] = data.barColor;
        model['backgroundColor'] = data.backgroundColor;
        model['useAlarmLimit'] = data.useAlarmLimit;
        if (data.useAlarmLimit) {
            model['upperLimit'] = data.upperLimit;
            model['lowerLimit'] = data.lowerLimit;
            model['upperLimitColor'] = data.upperLimitColor;
            model['lowerLimitColor'] = data.lowerLimitColor;
        }
        if (data.showPercentage) {
            model['percentageFont'] = new CalibrationGoModelToDataUtil(data).toViewData().percentageFont;
        }
        model['showScale'] = data.showScale;
        if (data.showScale) {
            model['masterDivisionNumber'] = data.masterDivisionNumber;
            model['subDivisionNumber'] = data.subDivisionNumber;
        }
        var barColor = data.barColor ? data.barColor : BarGraphConsts.defaultBarColor;
        var $bar = svg.find("path[fill='" + barColor + "']");
        $("<rect fill='transparent' transform='" + $bar.attr('transform') + "'></rect>").appendTo($bar.parent());
        var barText = $bar.parent().children('text').attr('id', 'text').text('');
        $bar.parent().children('text').remove();
        $(barText).appendTo($bar.parent());
        $bar.remove();
        if (data.percentageIsUnderline) {
            svg.find('path').last().remove();
        }
    };
    BarGraphElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/bar-graph.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    BarGraphElement.prototype.getDiagramTemplate = function () {
        var self = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Spot', {
            resizable: true,
            resizeObjectName: 'BAR',
            selectionObjectName: 'BAR',
            locationObjectName: 'BAR',
            locationSpot: go.Spot.TopLeft,
            segmentOrientation: go.Link.None,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('angle', 'direction', self.getBarGraphAngle), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, 'Rectangle', { name: 'BAR', fill: 'transparent', stroke: 'gray', strokeWidth: 1 }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('stroke', 'borderColor').makeTwoWay(), new go.Binding('fill', 'backgroundColor').makeTwoWay()), $(go.Panel, 'Graduated', {
            alignment: go.Spot.BottomLeft,
            alignmentFocus: go.Spot.BottomLeft,
            alignmentFocusName: 'line',
        }, new go.Binding('graduatedMax', 'max').makeTwoWay(), new go.Binding('graduatedMin', 'min').makeTwoWay(), new go.Binding('graduatedTickBase', 'min'), new go.Binding('visible', 'showScale').makeTwoWay(), new go.Binding('graduatedTickUnit', '', self.getGraduatedTickUnit).makeTwoWay(), $(go.Shape, { name: 'line', strokeWidth: 0 }, new go.Binding('geometryString', 'desiredSize', function (size, line) {
            var direction = line.panel.panel.data.direction;
            var minus = direction === BarDirectionType.DownToUp || direction === BarDirectionType.LeftToRight ? '-' : '';
            return "M0 0 V" + minus + size.height;
        }).ofObject('BAR'), new go.Binding('geometryString', 'direction', function (direction, line) {
            var size = go.Size.parse(line.panel.panel.data.size);
            var minus = direction === BarDirectionType.DownToUp || direction === BarDirectionType.LeftToRight ? '-' : '';
            return "M0 0 V" + minus + size.height;
        })), go.GraphObject.make(go.TextBlock, {
            alignmentFocus: go.Spot.RightCenter,
            segmentOffset: new go.Point(0, -12)
        }, new go.Binding('graduatedFunction', '', function (data) {
            return function (value) {
                if (data.integerDigits) {
                    if (data.fractionDigits > 0) {
                        if (data.variableDataType && +data.variableDataType === DataType.Float) {
                            return value.toFixed(data.fractionDigits);
                        }
                        else {
                            return (value / Math.pow(10, data.fractionDigits)).toFixed(data.fractionDigits);
                        }
                    }
                }
                return value.toFixed(0);
            };
        }), new go.Binding('alignmentFocus', 'direction', self.getTickMarkAlignmentFocus), new go.Binding('segmentOffset', 'direction', self.getTickMarkSegmentOffset), new go.Binding('segmentOrientation', 'direction', self.getTickMarkSegmentOrientation), new go.Binding('interval', 'subDivisionNumber', self.getDivisionInterval), new go.Binding('stroke', 'calibrationDigitColor').makeTwoWay(), new go.Binding('font', 'calibrationDigitFontStyle').makeTwoWay(), new go.Binding('isUnderline', 'calibrationDigitIsUnderline').makeTwoWay(), new go.Binding('visible', 'showCalibrationDigit').makeTwoWay()), go.GraphObject.make(go.Shape, { geometryString: 'M0 0 V5', stroke: 'gray', strokeWidth: 1 }, new go.Binding('visible', '', self.showSubDivisionNumber).makeTwoWay(), new go.Binding('stroke', 'calibrationColor').makeTwoWay(), new go.Binding('alignmentFocus', 'direction', self.getBarGraphDivisionAlignmentFocus)), go.GraphObject.make(go.Shape, { geometryString: 'M0 0 V10', stroke: 'black', strokeWidth: 1 }, new go.Binding('interval', 'subDivisionNumber', self.getDivisionInterval), new go.Binding('visible', '', self.showMasterDivisionNumber).makeTwoWay(), new go.Binding('alignmentFocus', 'direction', self.getBarGraphDivisionAlignmentFocus), new go.Binding('stroke', 'calibrationColor').makeTwoWay())), $(go.Shape, {
            strokeWidth: 0, fill: '#6fd149',
            width: 50, height: 80,
            alignment: go.Spot.Bottom,
            alignmentFocus: go.Spot.Bottom,
        }, new go.Binding('alignment', 'direction', self.getBarGarphBarAlignment), new go.Binding('alignmentFocus', 'direction', self.getBarGarphBarAlignment), new go.Binding('width', 'size', function (size) { return go.Size.parse(size).width; }), new go.Binding('height', 'size', function (size) { return go.Size.parse(size).height * 0.4; }), new go.Binding('fill', 'barColor').makeTwoWay()), go.GraphObject.make(go.TextBlock, {
            editable: false, text: '40%',
            visible: false, segmentOrientation: go.Link.None,
            alignment: go.Spot.Center,
        }, new go.Binding('visible', 'showPercentage').makeTwoWay(), new go.Binding('font', 'percentageFontStyle').makeTwoWay(), new go.Binding('stroke', 'percentageColor').makeTwoWay(), new go.Binding('isUnderline', 'percentageIsUnderline').makeTwoWay(), new go.Binding('angle', 'direction', self.getBarGraphPercentageAngle)));
    };
    BarGraphElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.barGraphKey;
    };
    BarGraphElement.prototype.getGraduatedTickUnit = function (data) {
        var masterDivisionNumber = data.masterDivisionNumber ? data.masterDivisionNumber : 1;
        var subDivisionNumber = data.subDivisionNumber ? data.subDivisionNumber : 1;
        var value = (data.max - data.min) / (masterDivisionNumber * subDivisionNumber);
        var num2 = Number(value.toFixed(14)).toString();
        var pointLength = num2.length - num2.lastIndexOf('.');
        if (pointLength > 13) {
            var formatValue = num2.substring(0, num2.lastIndexOf('.') + 12);
            return Number(formatValue).valueOf();
        }
        else {
            return value;
        }
    };
    BarGraphElement.prototype.getBarGraphAngle = function (direction) {
        switch (direction) {
            case BarDirectionType.UpToDown:
            case BarDirectionType.DownToUp:
                return 0;
            case BarDirectionType.LeftToRight:
            case BarDirectionType.RightToLeft:
                return 90;
        }
    };
    BarGraphElement.prototype.getBarGraphPercentageAngle = function (direction) {
        switch (direction) {
            case BarDirectionType.DownToUp:
            case BarDirectionType.UpToDown:
                return 0;
            case BarDirectionType.RightToLeft:
            case BarDirectionType.LeftToRight:
                return 270;
        }
    };
    BarGraphElement.prototype.getBarGraphDivisionAlignmentFocus = function (direction) {
        switch (direction) {
            case BarDirectionType.DownToUp:
            case BarDirectionType.LeftToRight:
                return go.Spot.Bottom;
            case BarDirectionType.UpToDown:
            case BarDirectionType.RightToLeft:
                return go.Spot.Default;
        }
    };
    BarGraphElement.prototype.getBarGarphBarAlignment = function (direction) {
        switch (direction) {
            case BarDirectionType.DownToUp:
            case BarDirectionType.LeftToRight:
                return go.Spot.Bottom;
            case BarDirectionType.RightToLeft:
            case BarDirectionType.UpToDown:
                return go.Spot.Top;
        }
    };
    BarGraphElement.prototype.getTickMarkAlignmentFocus = function (direction) {
        switch (direction) {
            case BarDirectionType.DownToUp:
            case BarDirectionType.UpToDown:
                return go.Spot.RightCenter;
            case BarDirectionType.RightToLeft:
                return go.Spot.TopCenter;
            case BarDirectionType.LeftToRight:
                return go.Spot.BottomCenter;
            default:
                throw new Error("Not supported direction:" + direction + ".");
        }
    };
    BarGraphElement.prototype.getTickMarkSegmentOrientation = function (direction) {
        switch (direction) {
            case BarDirectionType.DownToUp:
            case BarDirectionType.UpToDown:
                return go.Link.None;
            case BarDirectionType.LeftToRight:
                return go.Link.OrientAlong;
            case BarDirectionType.RightToLeft:
                return go.Link.OrientOpposite;
        }
    };
    BarGraphElement.prototype.getTickMarkSegmentOffset = function (direction) {
        switch (direction) {
            case BarDirectionType.DownToUp:
                return new go.Point(0, -12);
            case BarDirectionType.UpToDown:
                return new go.Point(0, 12);
            case BarDirectionType.LeftToRight:
                return new go.Point(0, -7);
            case BarDirectionType.RightToLeft:
                return new go.Point(0, 7);
            default:
                throw new Error("Not supported direction:" + direction + ".");
        }
    };
    BarGraphElement.prototype.getDivisionInterval = function (subDivisionNumber) {
        return subDivisionNumber ? subDivisionNumber : 1;
    };
    BarGraphElement.prototype.convertNumberToBoolean = function (value) {
        return value ? true : false;
    };
    BarGraphElement.prototype.showSubDivisionNumber = function (data) {
        if (!data.showScale) {
            return false;
        }
        return data.subDivisionNumber > 0;
    };
    BarGraphElement.prototype.showMasterDivisionNumber = function (data) {
        if (!data.showScale) {
            return false;
        }
        return data.masterDivisionNumber > 0;
    };
    return BarGraphElement;
}(NodeElement));
export { BarGraphElement };
